import * as React from 'react';
import * as moment from 'moment';
import { IEvent } from '../../custom/classes/event';
import { connect } from 'react-redux';

import UpNextView from 'up-next.view';
import { ICalendarAppState } from '../../redux-state';


interface IUpNextExternalProps {
}

interface StateToProps {
    upNext: IEvent;
}

export type UpNextProps = IUpNextExternalProps & StateToProps;

export class UpNextBase extends React.Component<UpNextProps, any> {
    render() {
        return (
            <UpNextView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IUpNextExternalProps): StateToProps {
    return {
        upNext: state.calendar.upNext
    }
}

export default connect<StateToProps>(mapStateToProps)(UpNextBase);